import React from "react";
import {Col, Row, Typography} from "antd";
import PropTypes from 'prop-types';

import EngageCurrency from "../EngageCurrency";
import {roundNumberUpToPrecision} from "../../../helpers/misc";

import {black, darkBlue, successGreen} from "../../../assets/colors";

const TaxableTransactionBreakdown = ({transaction}) => {
    const {amount, taxes} = transaction;

    const total = parseFloat(amount);
    let taxComponent = null;
    let taxTotal = 0.00;
    let subtotal = total;

    if (taxes !== undefined) {
        taxTotal = taxes.reduce((accu, curr) => {
            return accu + parseFloat(curr.amount);
        }, 0);

        subtotal = total - taxTotal;

        taxComponent = taxes.map(tax => {
            return <Row justify="space-between" key={tax.name}>
                <Col offset={2}>{tax.name} ({roundNumberUpToPrecision(tax.percent * 100, 2)}%)</Col>
                <Col>
                    <EngageCurrency amount={parseFloat(tax.amount)}/>
                </Col>
            </Row>;
        });
    }

    return <>
        <div style={{marginBottom: 24}}>
            <Row justify="space-between">
                <Col><Typography.Text strong>Subtotal:</Typography.Text></Col>
                <Col>
                    <EngageCurrency amount={subtotal}/>
                </Col>
            </Row>

            <Row justify="space-between">
                <Col><Typography.Text strong>Taxes:</Typography.Text></Col>
                <Col>
                    <EngageCurrency amount={taxTotal}/>
                </Col>
            </Row>

            {taxComponent}

        </div>

        <Row justify="space-between">
            <Col><Typography.Title level={5} style={{color: darkBlue}}>Total:</Typography.Title></Col>
            <Col>
                <Typography.Title level={5}>
                    <EngageCurrency
                        amount={total}
                        style={{color: total > 0 ? black : successGreen}}
                    />
                </Typography.Title>

            </Col>
        </Row>
    </>;
};

export default TaxableTransactionBreakdown;

TaxableTransactionBreakdown.propTypes = {
    transaction: PropTypes.shape({
        transactable: PropTypes.object.isRequired,
        amount: PropTypes.string.isRequired,
    }).isRequired,
};
